import { render, staticRenderFns } from "./Watercolor.vue?vue&type=template&id=373737ee&"
import script from "./Watercolor.vue?vue&type=script&lang=js&"
export * from "./Watercolor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports